module.exports = __webpack_public_path__ + "img/advantage.a529e736.jpg";